import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import CommonErrorContent from '../CommonErrorContent/CommonErrorContent';

const NoAccessToResource: FunctionComponent = () => {
  const { t } = useTranslation('authentication');

  const history = useHistory();

  const handleClick = (): void => {
    history.push('/home');
  };

  return (
    <CommonErrorContent
      title={t('AuthenticationComponent.errorModal.titleAccessFailedWhenAuthenticated')}
      content={t('AuthenticationComponent.errorModal.contentAccessFailedWhenAuthenticated')}
      buttonText={t('AuthenticationComponent.errorModal.mainPageButton')}
      onButtonClick={handleClick}
    />
  );
};

export default NoAccessToResource;
